<template>
  <Transition
    :css="false"
    @enter="scrollAnimation"
  >
    <main class="home-content scf-main-margins scf-row">
      <div class="scf-row__inner">
        <div class="home-intro scf-body-m">
          <p>
            I've always been a curious person interested in how thinks work.
          </p>
          <p>
            I've been playing video games since I was 7 y.o. and I have always
            wanted to create them myself.
          </p>
          <p>
            My real pasion is programing and allowing others to live exciting
            adventures to be involved in the game.
          </p>
        </div>
        <div
          v-for="(project, index) in mainProjects"
          :key="project.id"
        >
          <section
            class="card"
            :class="index % 2 == 0 ? 'even' : 'odd'"
            @click="
              $store.state.detailProject = project.id;
              $store.state.targetComponent = 'detailProject';
            "
            @mouseover="hovered = index"
            @mouseleave="hovered = null"
          >
            <div class="section-content">
              <div class="section-content--inner">
                <h2 class="section-title scf-heading-m scf-margin-bottom--xs">
                  {{ project.title }}
                </h2>
                <p
                  class="section-text scf-body-m"
                  v-html="project.introduction"
                ></p>
                <button
                  class="button--transparent"
                  aria-disabled="true"
                ></button>
              </div>
            </div>
            <picture>
              <img
                :src="
                  hovered == index
                    ? './images/projects/' + project.animGif[0].gif
                    : './images/projects/' + project.animGif[0].static
                "
                :alt="project.title"
              />
            </picture>
          </section>
        </div>
        <!-- About me -->
        <section
          class="card"
          :class="mainProjects.length % 2 === 0 ? 'even' : 'odd'"
          @click="$store.state.targetComponent = 'about me'"
          @mouseover="hovered = true"
          @mouseleave="hovered = null"
        >
          <div class="section-content">
            <div class="section-content--inner">
              <h2 class="section-title scf-heading-m">
                About me
              </h2>
              <p class="section-text scf-body-m">
                I'm a Junior Game Developer focused on programming and design. I live in Girona, Spain and I'm eager to contribute to team success through hard work, attention to detail and excellent organizational skills.
              </p>
              <button
                class="button--transparent"
                aria-disabled="true"
              ></button>
            </div>
          </div>
          <picture>
            <img
              :src="
                hovered == true
                  ? 'images/projects/sergi_about_me.gif'
                  : 'images/projects/sergi_about_me_static_gif.jpg'
              "
              alt="About me"
            />
          </picture>
        </section>

        <div class="home-quote scf-body-m">
          <figure>
            <blockquote
              cite="https://www.eurogamer.net/i-sidmeierpirates-dec2004"
            >
              "Our approach to making games is to find the fun first and then
              use the technology to enhance the fun."
            </blockquote>
            <figcaption>— Sid Meier, 2004</figcaption>
          </figure>
        </div>
      </div>
    </main>
  </Transition>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      hovered: null,
    };
  },
  computed: {
    mainProjects() {
      return this.$store.getters.getMainProjects;
    },
  },
  mounted: function () {
    this.scrollAnimation();
  },
  methods: {
    scrollAnimation() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../styles/all.less";

.home-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .card {
    cursor: pointer;
    border: 1px solid @white-20;
    background-color: transparent;
    transition: background-color 2s ease;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    margin-bottom: 20px;
    border-radius: @scf-border-radius;
    overflow: hidden;

    @media @scf-breakpoints--m {
      &.odd {
        flex-direction: row;
        picture {
          border-left: 1px solid @white-20;
        }
        .section-content--inner {
          align-items: flex-end;
        }
        .section-title,
        .section-text {
          text-align: end;
        }
      }
      &.even {
        flex-direction: row-reverse;
        picture {
          border-right: 1px solid @white-20;
        }
        .section-content-inner {
          align-items: flex-start;
        }
        .section-title,
        .section-text {
          text-align: start;
        }
      }
    }

    picture {
      position: relative;
      border-left: 1px solid @white-20;
      flex: 2;
      min-width: 50%;
      height: 400px;

      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
        object-position: center center;
        @supports (mix-blend-mode: luminosity) {
          mix-blend-mode: luminosity;
        }
        @supports not (mix-blend-mode: luminosity) {
          opacity: 1;
        }
      }
    }

    .section-text {
      display: -webkit-box;
      line-clamp: 4;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      opacity: 0;
      max-height: 0;
      transition: opacity 2s, max-height 1s;
    }

    &:hover {
      border-color: @white;
      background-color: @base-dark;
      transition: background-color 2s ease;

      &.odd {
        picture {
          border-left: 1px solid @white;
        }
      }
      &.even {
        picture {
          border-right: 1px solid @white;
        }
      }

      picture {
        img {
          @supports (mix-blend-mode: luminosity) {
            mix-blend-mode: normal;
          }
          @supports not (mix-blend-mode: luminosity) {
            opacity: 0.5;
          }
        }
      }

      .section-title {
        color: @accent;
      }
      .section-text {
        opacity: 1;
        max-height: 120px;
        transition: opacity 2s, max-height 1s;
      }
    }
  }

  .section-content {
    position: relative;
    flex-direction: column;
    align-self: center;
    width: 100%;

    @media @scf-breakpoints--m {
      width: 33.3333%;
      text-align: end;
    }
  }
  .section-content--inner {
    padding: @scf-space-l;
  }

  .home-intro {
    padding: @scf-space-l @scf-space-2xl;

    @media @scf-breakpoints--m {
      padding: @scf-space-l @scf-space-4xl @scf-space-xl;
    }
  }

  .home-quote {
    padding: @scf-space-l @scf-space-2xl;

    @media @scf-breakpoints--m {
      padding: @scf-space-xl @scf-space-4xl @scf-space-l;
    }

    blockquote {
      font-style: italic;
    }

    figcaption {
      text-align: right;
    }
  }
}
</style>
